// Exportación de emergencia del trabajo local (§13): borradores en un JSON y cada archivo pendiente
// como descarga separada, para conservarlos si la app no puede continuar.
import { fileStamp, formatIsoDateTime } from '../domain/dates.ts';
import { listDrafts } from './drafts.ts';
import { listQueue } from '../media/queue.ts';

function download(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export async function localWorkSummary(userId: string): Promise<{ drafts: number; files: number }> {
  try {
    const [drafts, queue] = await Promise.all([listDrafts(userId), listQueue(userId)]);
    return { drafts: drafts.length, files: queue.filter((q) => q.phase !== 'confirmed').length };
  } catch {
    return { drafts: 0, files: 0 };
  }
}

export async function exportLocalWork(userId: string): Promise<number> {
  const [drafts, queue] = await Promise.all([listDrafts(userId), listQueue(userId)]);
  const now = new Date();
  const stamp = fileStamp(now);
  const manifest = {
    exportado: formatIsoDateTime(now),
    borradores: drafts.map((d) => ({
      orden: d.orderId,
      numero_de_serie: d.serial,
      descripcion_problema: d.diagnosis,
      descripcion_proceso: d.solution,
      actualizado: formatIsoDateTime(new Date(d.updatedAt)),
    })),
    archivos: queue.map((q) => ({
      folio: q.folio,
      orden: q.orderId,
      tipo: q.kind,
      bytes: q.bytes,
      estado: q.phase,
      error: q.error,
    })),
  };
  download(
    new Blob([JSON.stringify(manifest, null, 2)], { type: 'application/json' }),
    `servicioos-trabajo-local-${stamp}.json`,
  );
  for (const item of queue) {
    download(item.blob, `folio-${item.folio}-${item.id.slice(0, 8)}.${item.kind === 'image' ? 'jpg' : 'mp4'}`);
  }
  return drafts.length + queue.length;
}
